module.exports = __webpack_public_path__ + "img/1459914e994bb6beda276f741adbbfd1.a77a0722.png";